import { Component } from '@angular/core';
import { Observable } from 'rxjs';

import { Breadcrumb } from './breadcrumb.model';
import { BreadcrumbService } from './breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  breadcrumbs$: Observable<Breadcrumb[]>;
  route: any = [];
  showButton = false;

  constructor(private readonly breadcrumbService: BreadcrumbService, readonly translate: TranslateService
    ,private authenticationService: AuthenticationService,) {
    this.breadcrumbService.breadcrumbs$.subscribe(res => {
      this.route = res[0];
    });
    this.authenticationService.showReloadButton$.subscribe(show => {
      this.showButton = show;
    });
  }
  reload(): void{
    this.authenticationService.triggerButtonClick();
  }
}
